<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import Button from 'dashboard/components-next/button/Button.vue';
import CaptainEmptyState from './CaptainEmptyState.vue';

const emit = defineEmits(['click']);

const { t } = useI18n();

const STEPS = [
  ['ADD', 'i-lucide-link'],
  ['FAQS', 'i-lucide-sparkles'],
  ['ANSWER', 'i-lucide-message-circle'],
];

const steps = computed(() =>
  STEPS.map(([key, icon]) => ({
    icon,
    title: t(`CAPTAIN.DOCUMENTS.EMPTY_STATE.STEPS.${key}.TITLE`),
    description: t(`CAPTAIN.DOCUMENTS.EMPTY_STATE.STEPS.${key}.DESCRIPTION`),
  }))
);
</script>

<template>
  <CaptainEmptyState
    icon="i-lucide-file-text"
    :title="t('CAPTAIN.DOCUMENTS.EMPTY_STATE.TITLE')"
    :subtitle="t('CAPTAIN.DOCUMENTS.EMPTY_STATE.SUBTITLE')"
    :steps="steps"
  >
    <template #actions>
      <Button
        :label="t('CAPTAIN.DOCUMENTS.ADD_NEW')"
        icon="i-lucide-plus"
        @click="emit('click')"
      />
    </template>
  </CaptainEmptyState>
</template>
